import { render, staticRenderFns } from "./AffirmDialog.vue?vue&type=template&id=3716c96d&scoped=true"
import script from "./AffirmDialog.vue?vue&type=script&lang=js"
export * from "./AffirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AffirmDialog.vue?vue&type=style&index=0&id=3716c96d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716c96d",
  null
  
)

export default component.exports